import type { Point2DInterface } from './Point2D';
import { distanceGreaterThanOrEqual } from './units';

export interface AxisAlignedBounds {
  readonly minX: number;
  readonly maxX: number;
  readonly minY: number;
  readonly maxY: number;
}

export function boundsOverlap(a: AxisAlignedBounds, b: AxisAlignedBounds): boolean {
  return (
    distanceGreaterThanOrEqual(a.maxX, b.minX) &&
    distanceGreaterThanOrEqual(a.maxY, b.minY) &&
    distanceGreaterThanOrEqual(b.maxX, a.minX) &&
    distanceGreaterThanOrEqual(b.maxY, a.minY)
  );
}

export function boundsContainPoint(bounds: AxisAlignedBounds, point: Point2DInterface): boolean {
  return (
    distanceGreaterThanOrEqual(point.x, bounds.minX) &&
    distanceGreaterThanOrEqual(bounds.maxX, point.x) &&
    distanceGreaterThanOrEqual(point.y, bounds.minY) &&
    distanceGreaterThanOrEqual(bounds.maxY, point.y)
  );
}

export function boundsContainPointWithinDistance(
  bounds: AxisAlignedBounds,
  point: Point2DInterface,
  distance: number,
): boolean {
  return (
    distanceGreaterThanOrEqual(point.x, bounds.minX - distance) &&
    distanceGreaterThanOrEqual(bounds.maxX + distance, point.x) &&
    distanceGreaterThanOrEqual(point.y, bounds.minY - distance) &&
    distanceGreaterThanOrEqual(bounds.maxY + distance, point.y)
  );
}
